/* unplugin-vue-components disabled */import { render } from "./finances.vue?vue&type=template&id=5994a5d8&scoped=true"
import script from "./finances.vue?vue&type=script&setup=true&lang=js"
export * from "./finances.vue?vue&type=script&setup=true&lang=js"

import "./finances.vue?vue&type=style&index=0&id=5994a5d8&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5994a5d8"],['__file',"src/components/cards-v2/company/finances.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5994a5d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5994a5d8', __exports__)) {
    api.reload('5994a5d8', __exports__)
  }
  
  module.hot.accept("./finances.vue?vue&type=template&id=5994a5d8&scoped=true", () => {
    api.rerender('5994a5d8', render)
  })

}


export default __exports__